// extracted by mini-css-extract-plugin
export default {"table":"Receipt_table__gwSZ6"};